import React, { useState } from 'react';
const CubicMeterCalculator = () => {
    const [length, setLength] = useState('');
    const [width, setWidth] = useState('');
    const [height, setHeight] = useState('');
    const [cubicMeter, setCubicMeter] = useState('');
    const [explanation, setExplanation] = useState('');
    const [error, setError] = useState('');
    const handleCalculate = () => {
        if (!length || !width || !height) {
            setError('الرجاء إدخال الأبعاد بشكل صحيح');
            setCubicMeter('');
            setExplanation('');
            return;
        }
        const lengthValue = parseFloat(length);
        const widthValue = parseFloat(width);
        const heightValue = parseFloat(height);
        if (isNaN(lengthValue) || isNaN(widthValue) || isNaN(heightValue)) {
            setError('الرجاء إدخال أبعاد صحيحة للمكعب');
            setCubicMeter('');
            setExplanation('');
            return;
        }
        const volume = lengthValue * widthValue * heightValue;
        setCubicMeter(volume.toFixed(2));
        setExplanation(
            `حجم المكعب (المتر المكعب) = الطول × العرض × الارتفاع = ${lengthValue} م × ${widthValue} م × ${heightValue} م = ${volume.toFixed(2)} م³`
        );
        setError('');
    };
    return (
        <div dir="rtl">
            <div>
                <div className="form-group d-flex align-items-center">
                    <b>
                        <label htmlFor='height' className="form-label ms-2" >الطول</label>
                    </b>
                    <input
                        type="number"
                        placeholder="30"
                        value={length}
                        onChange={(e) => setLength(e.target.value)}
                        className="form-control"
                        style={{ width: '150px' }}
                    />
                    <div className="input-group-append">
                        <span className="input-group-text">م</span>
                    </div>
                </div>
                <br />
                <div className="form-group d-flex align-items-center">
                <b>
                        <label className="form-label ms-2">العرض</label>
                    </b>
                    <input
                        type="number"
                        placeholder="20"
                        value={width}
                        onChange={(e) => setWidth(e.target.value)}
                        className="form-control"
                        style={{ width: '150px' }}
                    />
                    <div className="input-group-append">
                        <span className="input-group-text">م</span>
                    </div>
                </div>
                <br />
                <div className="form-group d-flex align-items-center">
                <b>
                        <label className="form-label ms-2">الارتفاع</label>
                    </b>
                    <input
                        type="number"
                        placeholder="14"
                        value={height}
                        onChange={(e) => setHeight(e.target.value)}
                        className="form-control"
                        style={{ width: '150px' }}
                    />
                    <div className="input-group-append">
                        <span className="input-group-text">م</span>
                    </div>
                </div>
                <br />
                <button
                    className="btn btn-success"
                    style={{ fontSize: '20px' }}
                    onClick={handleCalculate}
                >
                    احسب المتر المكعب
                </button>
            </div>
            <br />
            <div>
                {error !== '' ? (
                    <p className='p-3 mb-2 bg-warning text-white'>خطأ: {error}</p>
                ) : (
                    <>
                        {cubicMeter !== '' && (
                            <>
                                <p className='p-3 mb-2 bg-success text-white'>
                                    حجم المكعب (المتر المكعب): {cubicMeter} م³
                                </p>
                                {explanation !== '' && (
                                    <p className='p-3 mb-2 bg-info text-black'>
                                        خطوات الحل: <br />{explanation}
                                    </p>
                                )}
                            </>
                        )}
                    </>
                )}
            </div>
        </div>
    );
};
export default CubicMeterCalculator;
